import { render, staticRenderFns } from "./SalesReportFiling.vue?vue&type=template&id=574b2468&"
import script from "./SalesReportFiling.vue?vue&type=script&lang=js&"
export * from "./SalesReportFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports